import React, { useEffect, useState } from "react";
import TableAHSF from "../../../../Components/TableAHSF";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";
import { PiDropSimple } from "react-icons/pi";
import AddEdite_CoApplicantNames from "./AddEdite_CoApplicantNames";
import PopupAHSF from "../../../../Components/PopupAHSF";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import { GetAI_Co_ApplicantNamesData } from "../../../../Redux/Reducers/CoApplicantNames";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Account/EncryptionParams";

const CoApplicantNamesTable = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const [jsonData, setJsonData] = useState({});
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [aI_Co_applicantNamesId, setaI_Co_applicantNamesId] = useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      PersonalInformation: state.PersonalInformation.PersonalInformation,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const shouldDisableFields = !(
    //[,]
    // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
    (
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    )
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "commissioner",
      ShowStatus: true,
      NmaeColumn: "المفوض",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
      typeColumn: "text",
    },
    {
      KeyName: "fourSyllablesName",
      ShowStatus: true,
      NmaeColumn: "الاسم من ثلاث مقاطع",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    ,
    {
      KeyName: "gender",
      ShowStatus: true,
      NmaeColumn: "الجنس",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    ,
    {
      KeyName: "phoneNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الهاتف",
      TotalNumber: false,
      DropdownFiltrationStatus: true,
      DropdownFiltration: {
        keyTextName: "statusNameAr",
        keyValueName: "aP_StageId",
      },
      GroupOfColumns: false,
    },
    {
      KeyName: "emailAddress",
      ShowStatus: true,
      NmaeColumn: "  البريد الالكتروني",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "proofOfIdentityDocument",
      ShowStatus: true,
      NmaeColumn: "   مرفق وثيقة اثبات الشخصية",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      typeColumn: "file",
    },
  ];
  // Array holding button configurations for "Edit" and "Delete"
  const CoApplicantNamesBtns = [
    {
      Click: async (e) => {
        // Open the popup for editing

        setaI_Co_applicantNamesId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        // Show confirmation popup before deleting
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/AI_Co_ApplicantNames/DeleteAI_Co_ApplicantNames",
              {
                aI_Co_applicantNamesId: e.target.value,
              }
            );
            // Show success message after successful deletion
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            //refresh table data
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !shouldDisableFields,
    },
  ];

  const RequestsColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <AddEdite_CoApplicantNames />,
    title: " أسماء المشاركين / الشركاء في المشروع ",

    maxWidth: "500px",
    maxHeight: "500px",
  };
  // Pop-up body data object with dynamic popup body for editing co-applicant names

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEdite_CoApplicantNames
          aI_Co_applicantNamesId={aI_Co_applicantNamesId}
          BtnClick="edit"
        />
      </div>
    ),
    title: " أسماء المشاركين / الشركاء في المشروع ",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  //to get json data from main.js
  const getJson = async () => {
    var json = await loadConfig();
    return json;
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"aI_Co_applicantNamesId"}
        valueButtonAction={"aI_Co_applicantNamesId"}
        URL={`api/AI_Co_ApplicantNames/GetAI_Co_ApplicantNamesList`}
        UrlBody={{
          aI_BeneficiaryInformationId: props.aI_BeneficiaryInformationId,
          aI_ApplicationInformationId:
            localStorage.getItem("aI_ApplicationInformationId") ||
            decryptToken(AppGuid.AppGuid),
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={" أسماء المشاركين / الشركاء في المشروع "}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        modelCondition={state.PersonalInformation}
        KeyCondition={"emailAddress"}
        btnNotToShow="deleteBtn"
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        fileStoreName={"CoApplicantNames"}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={CoApplicantNamesBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
    </>
  );
};
export default CoApplicantNamesTable;
